var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 27"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.432 6a1.535 1.535 0 0 0-1.45.902 1.502 1.502 0 0 0 .301 1.667l5.148 5.407-5.148 5.397c-.312.284-.49.684-.494 1.106-.001.42.174.822.484 1.11.31.288.725.436 1.15.408a1.536 1.536 0 0 0 1.087-.554l6.129-6.437a1.502 1.502 0 0 0 0-2.07l-6.13-6.438A1.534 1.534 0 0 0 25.433 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "m18.495 1.357-6.424 22.98c-.13.444-.081.92.135 1.328.214.408.579.71 1.012.842.435.131.901.082 1.3-.14.396-.221.692-.595.82-1.038l6.424-22.98a1.775 1.775 0 0 0-.27-1.569A1.686 1.686 0 0 0 20.09.094c-.744.019-1.39.53-1.594 1.263",
    opacity: 0.377
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41 6a1.535 1.535 0 0 1 1.45.902 1.502 1.502 0 0 1-.301 1.667L4.41 13.976l5.148 5.397c.313.284.49.684.494 1.106.001.42-.174.822-.484 1.11-.31.288-.725.436-1.15.408a1.536 1.536 0 0 1-1.087-.554l-6.128-6.437a1.502 1.502 0 0 1 0-2.07l6.128-6.438A1.534 1.534 0 0 1 8.41 6z"
  }))));
};
export default SvgCode;